export default "__VITE_ASSET__Dd2ghrif__"